/**
 * Replaces HTML <br> tags with spaces in a string
 * @param {string} str - The input string that may contain <br> tags
 * @returns {string} - The string with <br> tags replaced by spaces
 */
export const replaceBrTags = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str.replace(/<br\s*\/?>/gi, ' ');
};

/**
 * Replaces HTML <br> tags with spaces in a string and trims extra whitespace
 * @param {string} str - The input string that may contain <br> tags
 * @returns {string} - The string with <br> tags replaced by spaces and trimmed
 */
export const replaceBrTagsAndTrim = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str.replace(/<br\s*\/?>/gi, ' ').replace(/\s+/g, ' ').trim();
};
